import { render, staticRenderFns } from "./DetailPolicy.vue?vue&type=template&id=2076e357&scoped=true"
import script from "./DetailPolicy.vue?vue&type=script&lang=js"
export * from "./DetailPolicy.vue?vue&type=script&lang=js"
import style0 from "./DetailPolicy.vue?vue&type=style&index=0&id=2076e357&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2076e357",
  null
  
)

export default component.exports